var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('DSTextElement',{staticClass:"c-percentage__text",attrs:{"color":_vm.color,"variant":"small-medium"}},[_vm._v(" "+_vm._s(_vm.percentString)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }